import { ancestorAxis, treeAspectMinorTabgroup } from 'uix/views/utils';
export const scidesk = {
    ...treeAspectMinorTabgroup,
    tabGroup: 'scidesk',
    layout: 'L131Split',
    acl: 'g:admin',
    filters: [
        ancestorAxis
    ],
    tabs: {
        start: {
            default: true,
            tabGroupDefault: true,
            parts: [
                {
                    type: 'Wikiblock',
                    showMenu: true,
                    filters: [
                        {
                            ident: 'scidesk/start',
                            type: 'getWikiRendered'
                        }
                    ]
                }
            ],
            datatype: [
                10,
                1
            ]
        },
        semsearch: {
            datatype: [
                10
            ],
            parts: [
                'TreeSearchSemantic'
            ],
            label: 'Semantisch'
        },
        autostruct: {
            parts: [
                'AutoStruct'
            ],
            datatype: [
                1
            ]
        },
        gboxes: {
            datatype: [
                10,
                0,
                1,
                2,
                3
            ],
            parts: [
                'GraphicBoxes'
            ],
            label: 'GBoxes'
        }
    }
};
